import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import HomePage from 'buyside/components/presentation/HomePage/homePage';

document.getElementById('mainReactApp')?.setAttribute('data-no-padding', 'true');

const HomePageRoot: FC = () => {
  return (
    <BrowserRouter basename="/pro">
      <HomePage />
    </BrowserRouter>
  );
};

export default HomePageRoot;
